import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { RentalComponent } from './pages/rental/rental.component';
import { TransarchitectComponent } from './pages/transarchitect/transarchitect.component';
import { FinanceComponent } from './pages/finance/finance.component';
import { ContactComponent } from './pages/contact/contact.component';
import { CreateAccountComponent } from './pages/create-account/create-account.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { CreateNewPasswordComponent } from './pages/create-new-password/create-new-password.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { EmailVerificationComponent } from './pages/email-verification/email-verification.component';
import { VerificationSuccessComponent } from './pages/verification-success/verification-success.component';
import { ModulesComponent } from './pages/modules/modules.component';
import { IndustriesComponent } from './pages/industries/industries.component';
import { AboutComponent } from './pages/about/about.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'modules', component: ModulesComponent },
  { path: 'industries', component: IndustriesComponent },
  { path: 'about', component: AboutComponent },
  { path: 'rental', component: RentalComponent },
  { path: 'transarchitect', component: TransarchitectComponent },
  { path: 'finance', component: FinanceComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'pricing', component: PricingComponent },
  { path: 'create-account', component: CreateAccountComponent },
  { path: 'email-verification', component: EmailVerificationComponent },
  { path: 'verification-success', component: VerificationSuccessComponent },
  { path: 'sign-in', component: SignInComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'create-new-password', component: CreateNewPasswordComponent },
  { path: '**', redirectTo: '' }
];

